<template>
  <validation-provider
    :mode="validationModeComputed"
    v-slot="{ errors, validate }"
    :vid="vid"
    :name="labelComputed"
    :rules="rulesComputed"
  >
    <v-file-input
      v-model="model"
      ref="self"
      class="file-input"
      :label="fullLabel"
      :error-messages="errors"
      :accept="accept"
      :disabled="disabled"
      :value="value"
      dense
      outlined
      :clearable="clearable"
      clear-icon="mdi-close"
      hide-details="auto"
      :multiple="multiple"
      @change="validate"
    ></v-file-input>
  </validation-provider>
</template>

<script>
import { ValidationProvider } from 'vee-validate'

export default {
  name: 'FileInput',

  components: {
    ValidationProvider,
  },

  props: {
    value: {
      type: [File, Array],
      required: false,
    },
    label: {
      type: String,
      required: true,
    },
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
    accept: {
      type: String,
      required: false,
      default: '',
    },
    rules: {
      type: String,
      required: false,
      default: null,
    },
    validationMode: {
      type: String,
      required: false,
      default: 'aggressive',
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false,
    },
    vid: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {}
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    fullLabel() {
      return this.required ? `${this.label} ${this.$t('ELE0024')}` : this.label
    },
    rulesComputed() {
      if (this.rules && this.required) {
        return `required|${this.rules}`
      } else if (this.required) {
        return 'required'
      } else if (this.rules) {
        return this.rules
      } else {
        return ''
      }
    },
    validationModeComputed() {
      return this.validationMode
    },
    labelComputed() {
      return this.label
    },
  },

  methods: {},

  // mounted() {
  //   // TABでカーソル移動する際、クリアアイコンをスキップするように設定
  //   const elements = this.$refs.self.$el.getElementsByClassName('mdi-close')
  //   if (elements) {
  //     elements[0].tabIndex = -1
  //   }
  // },
}
</script>

<style>
/* 背景色指定 */
.file-input > .v-input__control > .v-input__slot {
  background: #edeffd;
  margin-bottom: 2px;
}
/** ボーダー色指定 */
.file-input > .v-input__control > .v-input__slot > fieldset {
  border-style: solid;
  border-width: 2px;
  border-color: var(--v-primary-base) !important;
}
/* フォーカスが外れている場合のラベル色 */
.file-input:not(.v-input--is-disabled) > .v-input__control > .v-input__slot > .v-text-field__slot > .v-label {
  color: var(--v-primary-base) !important;
}
/** エラーメッセージの上端が欠けるのを回避 */
.file-input > .v-input__control .v-messages {
  margin-top: 1px;
}
/* 非活性の選択値のフォント色,ボーダー色 */
.file-input.v-input--is-disabled > .v-input__control > .v-input__slot > fieldset {
  background: #ffffff;
  border-color: rgba(0, 0, 0, 0.26) !important;
  border-width: 1px;
  color: #000000;
}
/* 非活性のラベル色 */
.file-input.v-input--is-disabled > .v-input__control > .v-input__slot > .v-text-field__slot > .v-label {
  color: #000000 !important;
}
</style>
